import { useCallback } from "react";
import StringHelpers from "helpers/StringHelpers";

export interface Filter {
  /** Returns whether a string contains a given reference. */
  (entry: string, reference: string | string[]): boolean;
}

/**
 * Provides localized string search functionality that is useful for filtering or matching items in a list.
 *
 * The reason we are not using Intl.Collator for this is that Intl.Collator **designed to compare full strings (not partial matches)** based on
 * locale-sensitive rules for sorting and comparison.
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Collator
 */
function useFilter(): Filter {
  return useCallback((entry: string, reference: string | string[]) => {
    if (entry.length === 0) return true;

    const normalizedSearchTerm = StringHelpers.removeDiacritics(entry.toLowerCase());
    let normalizedTargetTerm = "";
    if (typeof reference === "string") {
      normalizedTargetTerm = StringHelpers.removeDiacritics(reference.toLowerCase());
    } else {
      normalizedTargetTerm = reference.map((item) => StringHelpers.removeDiacritics(item.toLowerCase())).join(" ");
    }
    return normalizedTargetTerm.includes(normalizedSearchTerm);
  }, []);
}

export default useFilter;
